export default "__VITE_ASSET__Bgrl0Bqi__"